import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

const useDiscountCodeStatistics = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const getDiscountCodeStatistics = async (startDate, endDate, discountCodeId = null, branchId = null) => {
    const params = { startDate, endDate };
    if (discountCodeId) {
      params.discountCodeId = discountCodeId;
    }
    if (branchId) {
      params.branchId = branchId;
    }

    return sendRequest({
      url: '/api/v1/discountCode/statistics',
      method: 'GET',
      headers: authCtx.getAuthHeaders(),
      params,
    });
  };

  const downloadDiscountCodeStatisticsReport = async (
    startDate,
    endDate,
    discountCodeId = null,
    branchId = null
  ) => {
    const params = { startDate, endDate };
    if (discountCodeId) {
      params.discountCodeId = discountCodeId;
    }
    if (branchId) {
      params.branchId = branchId;
    }

    return sendRequest({
      url: '/api/v1/discountCode/statistics/report',
      method: 'GET',
      headers: authCtx.getAuthHeaders(),
      params,
      returnBlob: true,
    });
  };

  const downloadDiscountCodeStatisticsExcel = async (
    startDate,
    endDate,
    discountCodeId = null,
    branchId = null
  ) => {
    const params = { startDate, endDate };
    if (discountCodeId) {
      params.discountCodeId = discountCodeId;
    }
    if (branchId) {
      params.branchId = branchId;
    }

    return sendRequest({
      url: '/api/v1/discountCode/statistics/excel',
      method: 'GET',
      headers: authCtx.getAuthHeaders(),
      params,
      returnBlob: true,
    });
  };

  return {
    isLoading,
    error,
    getDiscountCodeStatistics,
    downloadDiscountCodeStatisticsReport,
    downloadDiscountCodeStatisticsExcel,
  };
};

export default useDiscountCodeStatistics;
